import { render, staticRenderFns } from "./wiki-robot-tip.vue?vue&type=template&id=c23d9738"
import script from "./wiki-robot-tip.vue?vue&type=script&lang=js"
export * from "./wiki-robot-tip.vue?vue&type=script&lang=js"
import style0 from "./wiki-robot-tip.vue?vue&type=style&index=0&id=c23d9738&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports